import Vue from "vue";
import AlertDialogBuilder from "./AlertDialogBuilder";
import DialogOverlay from "./DialogOverlay";

const bus = new Vue();

export default {

    install(Vue, options) {
        this.installPrototypes(Vue, options);
        const components = {DialogOverlay};
        Object.keys(components).forEach(key => Vue.component(key, components[key]));
    },
    installPrototypes: function (Vue, options) {
        Vue.prototype.$mps_dialog_event_bus = bus;
        Vue.prototype.$dialog = () => new AlertDialogBuilder(bus);
        Vue.prototype.$alert = (message) => new Promise((resolve) => {
            const vm = new Vue();
            return new AlertDialogBuilder(bus)
                .title(vm.$translate('알림'))
                .message(message)
                .buttonPositive(vm.$translate('확인'), resolve)
                .build()
                .show();
        });
        Vue.prototype.$confirm = (message) => new Promise((resolve, reject) => {
            const vm = new Vue();
            new AlertDialogBuilder(bus)
                .title(vm.$translate('확인'))
                .message(message)
                .buttonNegative(vm.$translate('취소'), reject)
                .buttonPositive(vm.$translate('확인'), resolve)
                .build()
                .show();
        });
    }

}
